/** @flow */
// eslint-disable-next-line no-unused-vars
export default function noop(...params) {}
